export interface ProductTags {
  SustainablyFarmed: Tag
  YourFavorite: Tag
  JMenu: Tag
  HighFiber: Tag
  HighIron: Tag
  NoPlastic: Tag
  HighVitaminC: Tag
  LowCal: Tag
  PlantBased: Tag
  ContainsProbiotic: Tag
  FrequentlyPurchased: Tag
  BoostingImmuneSystem: Tag
  HighVitaminB: Tag
  OceanLifeSafe: Tag
  HighVitaminD: Tag
  SugarFree: Tag
  RecycleablePackaging: Tag
  BestSeller: Tag
  PesticideFree: Tag
  Compostable: Tag
  GoodForBrain: Tag
  NoMSG: Tag
  CholesterolFree: Tag
  NonGMO: Tag
  ContainsFish: Tag
  GainingMuscle: Tag
  SupportsLocalCommunity: Tag
  FreeRange: Tag
  NoAddedSugar: Tag
  DirectFromFarmers: Tag
  ContainsEgg: Tag
  OrganicIngredients: Tag
  LowCarb: Tag
  LowGI: Tag
  LowSugar: Tag
  HighOmegaFat: Tag
  Light: Tag
  Biodegradable: Tag
  GlutenFree: Tag
  New: Tag
  Vegetarian: Tag
  HighCalcium: Tag
  PeanutFree: Tag
  LowFat: Tag
  LowUricAcid: Tag
  ContainsShrimp: Tag
  NoPreservatives: Tag
  SoyFree: Tag
  WeightControl: Tag
  GoodForBlood: Tag
  LowSodium: Tag
  Paleo: Tag
  HighVitaminA: Tag
  LandSafe: Tag
  DairyFree: Tag
  RecentlyPurchased: Tag
  Signature: Tag
  Homemade: Tag
  HighProtein: Tag
  Vegan: Tag
  GoodForSkin: Tag
  GoodForEyes: Tag
  GoodForBone: Tag
  ImprovingDigestion: Tag
  Sustainable: Tag
  HighAntioxidant: Tag
  LocallySourced: Tag
  CanbeJ: Tag
  Keto: Tag
  CanbeGlutenFree: Tag
  Exclusive: Tag
}

export interface Tag {
  nameEn: string
  nameTh: string
  categories: TagCategory[]
}

export interface Tag {
  nameEn: string
  nameTh: string
  categories: TagCategory[]
  bgColor?: string
  color?: string
  icon?: string
}

export enum TagCategory {
  Benefit = 'benefit',
  Diet = 'diet',
  Environmental = 'environmental',
  Fitness = 'fitness',
  Wellness = 'wellness',
  Complementary = 'complementary',
  Restriction = 'restriction',
  SpecialNeeds = 'special-needs',
  Other = 'other',
}
